export class PriceRobotFilter {

    currentUser: boolean;
    user: number;
    variantIds: number[];
    categoryIds: number[];
    minPrice: number;
    maxPrice: number;

    minDeviation: number;
    maxDeviation: number;

    pending: boolean;
    withErrors: boolean;

    query?: string;
    robotStatus?: string | 'active' | 'all' | 'inactive' = 'all';
    webActive?: string | 'yes' | 'no' | 'all' = 'yes';
    campaignStatus?: string | 'active' | 'all' | 'inactive' = 'all';
    urlStatus?: string | 'hasCrawlerUrls' | 'noCrawlerUrls' | 'all' = 'all'
    sendingStatus?: string | 'active' | 'notify' | 'all' = 'all'
    selectedVariants?: any = {}
    selectedCategories?: any = [];
    selectedPriceCategory?: string | 'none' | 'Billigst' | 'Samme' | 'Dyrere' | 'Dyrest' = 'none';

    sort: string = null;
    direction: string = 'ASC';

    static _JSONProps: string[] = [
        'id'
    ];

    constructor() {
        this.resetFilter();
    }

    static fromJSON(json: PriceRobotFilterJSON | string): PriceRobotFilter {
        if (json === null) {
            return new PriceRobotFilter();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, PriceRobotFilter.reviver);
        } else {
            const priceRobotFilter = Object.create(PriceRobotFilter.prototype);

            priceRobotFilter.resetFilter();

            const extra = {};

            Object.keys(json).forEach((key, index) => {
                //if (key === 'basket') {
                //    extra.basket = Basket.fromJSON(json[key]);
                //}
            });

            return Object.assign(priceRobotFilter, json, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === '' ? PriceRobotFilter.fromJSON(value) : value;
    }


    resetFilter() {
        this.currentUser = false;
        this.user = 0;
        this.variantIds = [];
        this.categoryIds = [];
        this.minPrice = 0;
        this.maxPrice = 0;
        this.minDeviation = 0;
        this.maxDeviation = 0;
        this.pending = false;
        this.withErrors = false;
        this.selectedVariants = {}
        this.sort = null;
        this.direction = 'ASC';
        this.selectedCategories = [];
        this.selectedPriceCategory = 'none';

        this.robotStatus = 'all';
        this.webActive = 'yes';
        this.campaignStatus = 'all';
        this.urlStatus = 'all';
        this.sendingStatus = 'all';
        this.query = '';

    }
}

// A representation of PriceRobotFilter data that can be converted to
// and from JSON without being altered.
export interface PriceRobotFilterJSON {
    currentUser?: boolean;
    user?: number;
    variantIds?: number[];
    categoryIds?: number[];
    minPrice?: number;
    maxPrice?: number;

    minDeviation?: number;
    maxDeviation?: number;

    pending?: boolean;
    withErrors?: boolean;

    query?: string;
    robotStatus?: string;
    webActive?: string;
    campaignStatus?: string;
    urlStatus?: string;
    sendingStatus?: string;
    selectedVariants?: any;
    selectedCategories?: any;
    selectedPriceCategories?: string;

    sort?: string;
    direction?: string;
}
